import gql from 'graphql-tag';
import OrderLineItemsFragment, { OrderLineItem } from './fragments/OrderLineItems';
import OrderEditableFieldsFragment, { OrderEditableFields } from './fragments/OrderEditableFields';

export const getOrderDataQuery = gql`
  ${OrderEditableFieldsFragment}
  ${OrderLineItemsFragment}
  query($orderId: ID!, $take: Int!, $cursor: String) {
    order(id: $orderId) {
      ...OrderEditableFields
      name
      customer {
        firstName
        email
        validEmailAddress
      }
      totalPriceSet {
        shopMoney {
          amount
          currencyCode
        }
      }
      lineItems(first: $take, after: $cursor) {
        ...LineItems
      }
    }
  }
`;

export const getOrderItemsQuery = gql`
  ${OrderLineItemsFragment}
  query($orderId: ID!, $take: Int!, $cursor: String) {
    order(id: $orderId) {
      lineItems(first: $take, after: $cursor) {
        ...LineItems
      }
    }
  }
`;

export const getOrderDataOpts = (id: string, cursor?: string) => ({
  variables: {
    orderId: `gid://shopify/Order/${id}`,
    take: 9,
    cursor,
  },
});

export type OrderData = {
  name: string;
  customer: {
    firstName: string;
    email: string;
    validEmailAddress: boolean;
  };
  totalPriceSet: {
    shopMoney: {
      amount: string;
      currencyCode: string;
    };
  };
  lineItems: {
    edges: {
      node: OrderLineItem;
      cursor: string;

    }[];
    pageInfo: {
      hasNextPage: boolean;
    };
  };
} & OrderEditableFields;

export type OrderDataResponse = {
  order: OrderData | null;
}